import LINK from '../constants/link';

// 로그인 시작 화면 자신으로 돌아가는 목적지는 재진입 루프를 만들므로 허용하지 않는다
const LOGIN_PATHNAMES = ['/', '/login'];
// 라우터가 해석하는 것과 같게 경로를 정규화하기 위한 내부 기준 origin
const INTERNAL_ORIGIN = 'http://internal.invalid';
// 이 페이지 로드에서만 유효한 표식. 새로고침으로 살아남은 history.state 는 다른 값이 되어 자동 복원을 생략시키지 않는다
const PAGE_LOAD_TOKEN = `restore-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;

// './', '../', 중복·후행 슬래시, 대소문자를 정규화한 pathname 을 돌려준다. 내부 경로가 아니면 null
function normalizePathname(value) {
	try {
		const url = new URL(value, INTERNAL_ORIGIN);
		if (url.origin !== INTERNAL_ORIGIN) return null;
		let pathname = url.pathname.replace(/\/+/g, '/').toLowerCase();
		if (pathname.length > 1) pathname = pathname.replace(/\/+$/, '');
		return pathname;
	} catch (error) {
		return null;
	}
}

/** 단일 슬래시로 시작하는 앱 내부 경로만 허용한다. `//`, 역슬래시, scheme, 외부 origin, 로그인 자기 복귀(정규화 후)는 거부한다. */
export function isSafeInternalPath(value) {
	if (typeof value !== 'string' || !value.startsWith('/')) return false;
	if (value.startsWith('//') || value.includes('\\')) return false;
	const pathname = normalizePathname(value);
	return pathname !== null && !LOGIN_PATHNAMES.includes(pathname);
}

/** 로그인 화면의 search 에서 내부 목적지를 얻는다. 없거나 안전하지 않으면 홈으로 보낸다. */
export function resolveAuthRedirect(search) {
	const redirection = new URLSearchParams(search ?? '').get('redirection');
	return isSafeInternalPath(redirection) ? redirection : LINK.HOME;
}

/** 로그인 화면 경로를 만든다. reason 은 화면 정책용 표식이며, redirection 은 검증 후 인코딩해 보존한다. */
export function buildLoginPath({ reason, redirection } = {}) {
	const params = new URLSearchParams();
	if (reason) params.set('reason', reason);
	if (isSafeInternalPath(redirection)) params.set('redirection', redirection);
	const query = params.toString();
	return query ? `/login?${query}` : '/login';
}

/** 보호 경로가 방금 복원을 확인하고 로그인 화면으로 보낼 때 붙이는 router state. 같은 페이지 로드에서만 유효하다. */
export function restoreCheckedState() {
	return { sessionRestore: PAGE_LOAD_TOKEN };
}

/** 로그인 화면이 같은 사유의 복원을 반복하지 않아도 되는지 판단한다. 쿠키 상태의 증거가 아니라 화면 정책일 뿐이다. */
export function isRestoreChecked(state) {
	return state?.sessionRestore === PAGE_LOAD_TOKEN;
}
